var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar"},_vm._l((_vm.toolbarBlocks),function(toolbarBlock,index){return _c('toolbar-block',{key:index,attrs:{"toolbarBlock":toolbarBlock},on:{"onClickToolbarItem":_vm.onClickToolbarItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }